import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ScrollTrigger } from '@/animations/gsap';
import it from '@/content/it';
import en from '@/content/en';
import { withBreaks } from '@/content/breaks';

const CONTENT = { it: withBreaks(it), en: withBreaks(en) };

const LanguageContext = createContext({ lang: 'it', setLang: () => {}, t: it });

const getInitial = () => {
  try {
    const p = new URLSearchParams(window.location.search).get('lang');
    if (p === 'en' || p === 'it') return p;
    const saved = window.localStorage.getItem('panoz-lang');
    if (saved === 'en') return 'en';
  } catch (e) {
    /* ignore */
  }
  return 'it';
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitial);

  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem('panoz-lang', lang);
      const url = new URL(window.location);
      url.searchParams.set('lang', lang);
      window.history.replaceState(null, '', url);
    } catch (e) {
      /* ignore */
    }
    const t = setTimeout(() => ScrollTrigger.refresh(), 100);
    return () => clearTimeout(t);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: CONTENT[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
